import { render, staticRenderFns } from "./IllustrationCashHandCroppedRight.svg?vue&type=template&id=7f056c12&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports